module.exports = __webpack_public_path__ + "static/WindingWorlds7-0f701bbe70faca6042f033531e19d6a2.webp";